import { render, staticRenderFns } from "./WhoIAmHeading.vue?vue&type=template&id=63451572&lang=pug&"
import script from "./WhoIAmHeading.vue?vue&type=script&lang=js&"
export * from "./WhoIAmHeading.vue?vue&type=script&lang=js&"
import style0 from "./WhoIAmHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports